import { useState, useEffect } from 'react';
import './NavigationDrawer.css';
import { navItems } from '../data/navItems';

interface NavigationDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onNavigate: (page: string) => void;
}

const NavigationDrawer: React.FC<NavigationDrawerProps> = ({ isOpen, onClose, onNavigate }) => {
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const handleNavigation = (page: string): void => {
    onNavigate(page);
    onClose();
    setActiveDropdown(null);
  };

  const toggleDropdown = (label: string) => {
    setActiveDropdown(activeDropdown === label ? null : label);
  };

  const handleSubmenuClick = (page: string, sectionId?: string): void => {
    onNavigate(page);
    onClose();
    setActiveDropdown(null);
    if (sectionId) {
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const handleContactClick = (): void => {
    onNavigate('home');
    onClose();
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <>
      {/* Backdrop */}
      {isOpen && <div className="drawer-backdrop" onClick={onClose} />}

      {/* Drawer */}
      <div className={`navigation-drawer ${isOpen ? 'open' : ''}`}>
        <div className="drawer-header">
          <h2>Navigation</h2>
          <button className="drawer-close-button" onClick={onClose} aria-label="Close menu">
            ×
          </button>
        </div>

        <nav className="drawer-nav">
          {navItems.filter(item => !item.isContact).map((item) => {
            if (item.subItems) {
              return (
                <div key={item.label} className="drawer-menu-group">
                  <div className="drawer-item-row">
                    <button
                      className="drawer-nav-item"
                      onClick={() => item.page ? handleNavigation(item.page) : toggleDropdown(item.label)}
                    >
                      {item.label}
                    </button>
                    <button
                      className={`drawer-toggle-btn ${activeDropdown === item.label ? 'active' : ''}`}
                      onClick={() => toggleDropdown(item.label)}
                    >
                      ▼
                    </button>
                  </div>
                  {activeDropdown === item.label && (
                    <div className="drawer-submenu">
                      {item.subItems.map((sub, index) => (
                        <button
                          key={index}
                          className="drawer-nav-item submenu-item"
                          onClick={() => handleSubmenuClick(sub.page, sub.sectionId)}
                        >
                          {sub.label}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            }

            return (
              <button
                key={item.label}
                className="drawer-nav-item"
                onClick={() => item.page && handleNavigation(item.page)}
              >
                {item.label}
              </button>
            );
          })}
        </nav>
        <div className="drawer-footer">
          <button className="contact-btn-mobile" onClick={handleContactClick}>
            Contact Us
          </button>
        </div>
      </div>
    </>
  );
};

export default NavigationDrawer;
